export enum TypeQuestion {
  NONE,
  OPTIONAL_MULTIPLE,
  TEXT,
  ONE_SELECTION
}
